export const fundingFAQsInformation = [
  {
    title: 'Funding FAQ 01',
    text: `Specific funding related intro wed ut persp iciatis unde omnis iste natus error sit volup tatem accusantium doloremque...`
  },
  {
    title: 'Funding FAQ 02',
    text: `Specific funding related intro wed ut persp iciatis unde omnis iste natus error sit volup tatem accusantium doloremque...`
  },
  {
    title: 'Funding FAQ 03',
    text: `Specific funding related intro wed ut persp iciatis unde omnis iste natus error sit volup tatem accusantium doloremque...`
  },
  {
    title: 'Funding FAQ 04',
    text: `Specific funding related intro wed ut persp iciatis unde omnis iste natus error sit volup tatem accusantium doloremque...`
  }
];
